import { trackEvent, EventAction, EventCategory } from './Analytics'
import * as MvoApiService from './MvoApiService'

export const maxWidthForSection = 1200;

export const getDuration = (sec_num) => {
  let roundedTime = Math.round(sec_num)
  let hours   = Math.floor(roundedTime / 3600)
  let minutes = Math.floor((roundedTime - (hours * 3600)) / 60)
  let seconds = roundedTime - (hours * 3600) - (minutes * 60)

  if (minutes < 10 && hours !== 0) {minutes = "0"+minutes}
  if (seconds < 10) {seconds = "0"+seconds}
  if (hours === 0) {hours = ""}

  return (hours ? hours+':' : "")+minutes+':'+seconds
}

export const openLinkInSameTab = link => {
  window.open(link, "_self")
}

export const openLinkInNewTab = link => {
  window.open(link, "_blank")
}

export const onVideoClick = (playlistId, videoDetails, sectionNumber, voltaxView) => {
  trackEvent(EventCategory.Sections, EventAction.PlayedVideoInSection(sectionNumber), videoDetails.payload_id)
  MvoApiService.openOverlay({ playlistId, videoDetails, voltaxView })
}
